/*>
* @license
* Copyright (c) 2014-2022 ABILITY Network, Inc., an INOVALON, Inc. company. All Rights Reserved.
* 
* This computer program is CONFIDENTIAL and a TRADE SECRET of ABILITY Network, Inc.
* The receipt or possession of this program does not convey any rights to use,
* reproduce or disclose its contents in whole or in part, without the specific
* written consent of ABILITY Network, Inc. Any use, reproduction or disclosure of
* this program without the express written consent of ABILITY Network, Inc. is a
* violation of the copyright laws and may subject you to criminal prosecution.
<*/
export class ErrorHelper {
	static handleApiError(error: { response: { status: number } | null }): void {
		if (error.response !== null && typeof error.response !== 'undefined' && error.response.status === 401) {
			alert('Your session has expired')
			window.location.href = '/'
		} else {
			throw error
		}
	}
}
